import React from "react";
import {WordSearchComponent} from "../components/WordSearchComponent";
import {RecentWordsComponent} from "../components/RecentWordsComponent";



export const MainPage: React.FC<any> = () => {
	return (
		<>
			<WordSearchComponent/>
			<RecentWordsComponent/>
		</>
	)
};